import PendoIcon from '../../icon/pendo-icon.vue.js';
import PendoLoadingIndicator from '../../loading-indicator/pendo-loading-indicator.vue.js';
import PendoMultiselect from '../../multiselect/pendo-multiselect.vue.js';
import PendoInput from '../../input/pendo-input.vue.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'MultiselectCell',
  components: {
    PendoIcon,
    PendoInput,
    PendoLoadingIndicator,
    PendoMultiselect
  },
  inject: ['$table'],
  props: {
    row: {
      type: Object,
      required: true
    },
    value: {
      type: [Object, String, Number],
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    groupOptionsKey: {
      type: String,
      default: undefined
    },
    groupLabelKey: {
      type: String,
      default: undefined
    },
    valueKey: {
      type: String,
      default: undefined
    },
    minMenuWidth: {
      type: String,
      default: '200'
    },
    optionHeight: {
      type: Number,
      default: 26
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    triggerClasses() {
      return ['pendo-multiselect__trigger', 'pendo-multiselect__trigger--mini', {
        'is-disabled': this.loading || this.disabled
      }];
    }
  },
  watch: {
    '$table.scrollStore.scrollActive': function (value) {
      if (value) {
        this.isOpen = false;
      }
    }
  },
  methods: {
    toggleMultiselect: _async(function () {
      const _this = this;
      if (_this.loading || _this.disabled) {
        return;
      }
      _this.isOpen = true;
      return _await(_this.$nextTick(), function () {
        if (_this.$refs.multiselectCell) {
          _this.$refs.multiselectCell.toggleMenu();
        }
        return _await(_this.$nextTick(), function () {
          _this.$refs.searchInput.focus();
        });
      });
    })
  }
};

export { script as default };
//# sourceMappingURL=multiselect-cell.vue2.js.map
